import React, { useEffect } from "react";
// import Button from 'react-bootstrap/esm/Button';
import Container from "react-bootstrap/esm/Container";
import Table from "react-bootstrap/esm/Table";
import { useDispatch, useSelector } from "react-redux";
// import { Link } from 'react-router-dom';
import MyTag from "../component/MyTag";
import { fetchTags } from "../store/actions/creator";

export default function TagsPage() {
  const dispatch = useDispatch();

  useEffect(() => dispatch(fetchTags()), [dispatch]);
  const { searchQuery } = useSelector((state) => state.custom);
  const { tags } = useSelector((state) => state.tag);

  return (
    <Container>
      <br />  
      <h1>Table of Tags</h1>
      <Table striped bordered hover >
        <thead>
          <tr>
            <th>No</th>
            <th>Name</th>
            <th style={{width : '50%'}}>News</th>
            <th>Created At</th>
            <th>Updated At</th>
          </tr>
        </thead>
        <tbody>
          {tags
            .filter((el) =>
              el.name.toLowerCase().includes(searchQuery.toLowerCase())
            )
            .map((tag, index) => {
              return <MyTag tag={tag} key={tag.id} index={index} />;
            })}
        </tbody>
      </Table>
    </Container>
  );
}
